import * as React from "react";
import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";

/* Riga di elenco (pacchetto del 29-10). Alta almeno 48 (64 con due righe). Al passaggio surface-2;
   scelta con l'anello interno da 2 px, mai una barra colorata a sinistra. Con href è un link (Link del
   router, così non ricarica la pagina); senza, un pulsante. Le azioni stanno fuori dall'area cliccabile. */
export function Initials({ name, muted = false, size = 40 }) {
  const iniziali = String(name || "")
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((p) => p[0]?.toUpperCase())
    .join("");
  return (
    <span
      aria-hidden="true"
      style={{ width: size, height: size }}
      className={cn(
        "inline-flex shrink-0 items-center justify-center rounded-full text-caption font-bold",
        muted ? "bg-surface-3 text-ink-2" : "bg-brand-subtle text-brand-ink",
      )}
    >
      {iniziali}
    </span>
  );
}

export function ListRow({ title, meta, leading, trailing, actions, selected = false, href, onClick, className, ...props }) {
  const inner = (
    <>
      {leading}
      <span className="min-w-0 flex-1">
        <span className="block truncate font-semibold text-ink-strong">{title}</span>
        {meta && <span className="block truncate text-small text-ink-2">{meta}</span>}
      </span>
      {trailing && <span className="shrink-0 font-bold tabular-nums text-ink-strong">{trailing}</span>}
    </>
  );
  const area = cn(
    "flex min-h-12 min-w-0 flex-1 items-center gap-3 px-4 py-2.5 text-left",
    "focus-visible:outline focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-brand",
    meta && "min-h-16",
  );
  return (
    <div
      data-slot="list-row"
      className={cn(
        "flex items-center border-b border-line-subtle bg-surface transition-colors duration-150 ease-enter hover:bg-surface-2",
        selected && "bg-surface-2 shadow-[inset_0_0_0_2px_var(--brand)]",
        className,
      )}
    >
      {href ? (
        <Link to={href} aria-current={selected ? "page" : undefined} className={area} {...props}>
          {inner}
        </Link>
      ) : (
        <button type="button" onClick={onClick} aria-current={selected ? "true" : undefined} className={area} {...props}>
          {inner}
        </button>
      )}
      {actions && <div className="flex shrink-0 items-center gap-2 pr-4">{actions}</div>}
    </div>
  );
}
